import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import {customerExportData, getCustomerList, schoolExportData} from '@/api/common'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { delNullProperty } from '@/utils/index'
import commonData from "@/utils/commonData";


@Component({})
export default class SchoolList extends Vue {
    socket: any = null
    tableHeadPopoverShow = false
    tableData: any= []
    tableHeader: any = []
    checkTableRow: any = []
    tableHeadFilter = {
        attendSchool: '',
        gradeList: [],
        specialized :'',
        souCourseName :'',
        souCourseSchoolBegin:'',
        souCourseTypeIdList : [],
        souTeacherName:'',
    }
    page = 1
    limit = 20
    total = 0
    selfTotal = 0

    gradeList = [  // 年级列表
        '美制7年级/英制8年级/初一（普高）',
        '美制8年级/英制9年级/初二（普高）',
        '美制9年级/英制10年级/初三（普高）',
        '美制10年级/英制11年级/高一（普高）',
        '美制11年级/英制12年级/高二（普高）', '美制12年级/英制13年级/高三（普高）',
        '大学一年级',
        '大学二年级',
        '大学三年级',
        '大学四年级',
        '研究生及以上',
        '已毕业'
    ]

    loading = false

    menuBtn = menuBtn

    timer = null
    typeList= commonData.projectTypeArray
    createdAt: Date[] | null = null
    exportButtonDisabled = false

    // computed

    get userId() {
        return UserModule.userId
    }

    // created
    created() {
        this.getTableData()

    }



    getRowKeys (row: any) {
        return row.id
    }

    async getTableData() {
        this.loading = true

        this.tableHeadFilter.souCourseSchoolBegin = this.changeTime(this.createdAt as Date[])
        const obj = { ...this.tableHeadFilter, page: this.page, limit: this.limit }
        await getCustomerList(delNullProperty(obj)).then((res) => {
            const data: any = res
            this.tableData = data.financeOrderList
            this.total = data.allNum

            this.$nextTick(() => {
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            });
            this.loading = false
        }).catch((err) => {
            this.loading = false
        })
    }

    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
        })
        time = time.slice(0, time.length - 1)
        return time
    }

    // 导出
    async exportExcel() {
        this.exportButtonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        this.tableHeadFilter.souCourseSchoolBegin = this.changeTime(this.createdAt as Date[])
        const obj = { ...this.tableHeadFilter, page: this.page, limit: this.limit }
        customerExportData(delNullProperty(obj)).finally(() => {
            this.exportButtonDisabled = false
        })
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }
    // ClickTableRow(row: any, col: any) {
    //     if (!this.menuBtn(34)) return
    //     if (col.label !== '操作' && row.isReceive === 1) {
    //         const win = window.open(window.location.origin + this.$route.matched[0].path + '/transfromCustomerInfo?id=' + row.id)
    //         const time = setInterval(() => {
    //             if(win.closed) {
    //                 this.getTableData()
    //                 clearInterval(time)
    //             }
    //         }, 500)
    //     }
    // }

}
